import { useCallback, useMemo, useState } from "react";
import { useMutation, useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { TConfiguracaoBancaria } from "../../../../../types/api/financeiro/configuracoes-bancarias";
import { Button, Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DialogEditAddIntegracaoLoja from "./DialogEditAddIntegracaoLoja";
import SelectIntegracaoBancaria from "../../../../../components/SelectsSimpleApiQuery/SelectIntegracaoBancaria";

export default function Boletos() {

  const [configPadrao, setConfigPadrao] = useState<TConfiguracaoBancaria | null>(null);
  const [openModal, setOpenModal] = useState<TOpenModalBoleto>(null)

  //queries e mutations
  const { data, isLoading: isLoadingConfiguracoes, refetch } = useQuery({
    queryKey: ["configuracoes"],
    queryFn: () => axiosClient.get("/configuracoes", {
      params: {
        chave: 'comercial_boletos'
      }
    })
  });


  const dataConfigBoleto: IConfigBoleto | null = useMemo(() => data?.data || null, [data])

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TPadraoLojas | null) => {
    if (action === "close") {
      setOpenModal(null)
    }
    if (action === "open" && typeof id === "number" && value) {
      setOpenModal({ open: id, defaultValue: value })
    }
    if (action === "open" && id === true && !value) {
      setOpenModal({ open: true, defaultValue: null })
    }
  }, [])

  const handleSuccess = useCallback(() => {
    refetch();
  }, [refetch]);

  if (isLoadingConfiguracoes) {
    return <LoadingApiQuery />
  }

  return (
    <>
      {dataConfigBoleto && (
        <>
    
            <Stack mb={2}>
              <Typography variant="body2" color="info.main" sx={{ background: '#e3f2fd', p: 1, borderRadius: 1 }}>
                Atenção: Caso nenhuma loja tenha configuração, a configuração padrão <b>{dataConfigBoleto?.padrao_boleto?.nome_banco || 'Nenhuma configuração padrão definida'}</b> será utilizada para todos os boletos.
              </Typography>
            </Stack>

          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography mt={2} variant="body1" gutterBottom>
              <b>Configuração de lojas:</b>
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => handleModalAction("open", true, null)}
            >
              Adicionar Loja
            </Button>
          </Stack>

          {dataConfigBoleto.padrao_lojas && dataConfigBoleto.padrao_lojas.length > 0 && (
            <TableContainer>
              <Table size={'small'}>
                <TableHead>
                  <TableRow>
                    <TableCell><b>Loja</b></TableCell>
                    <TableCell><b>Integração</b></TableCell>
                    <TableCell align="right"><b>Ações</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataConfigBoleto.padrao_lojas.map((item) => (
                    <TableRow key={item.loja_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell>{item.loja_id} - {item.loja_nome}</TableCell>
                      <TableCell>{item.integracao.nome_banco}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          onClick={() => handleModalAction("open", item.loja_id, item)}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}

      {Boolean(openModal?.open) && (
        <DialogEditAddIntegracaoLoja
          configBoleto={dataConfigBoleto}
          open={Boolean(openModal?.open)}
          handleClose={() => handleModalAction("close")}
          defaultValue={openModal}
          onSuccess={handleSuccess}
        />
      )}
    </>
  )
}

export interface IConfigBoleto {
  padrao_boleto: TIntegracao;
  padrao_lojas: TPadraoLojas[]
}

export type TPadraoLojas = {
  loja_id: number;
  loja_nome: string;
  integracao: TIntegracao;
};

export type TOpenModalBoleto = {
  open: number | boolean;
  defaultValue: TPadraoLojas | null;
} | null

type TIntegracao = {
  id: number;
  nome_banco: string;
}